export default __webpack_public_path__ + "images/ALA_Logo.svg";